<script>
  import { fade } from 'svelte/transition';

  export let visible;
  export let id;
  export let headline;
  export let copy;
  export let step = 0;

  // export let position = {top, left, bottom, right};
  // export let size = {width, height, min_width, min_height, max_width, max_height};

  $: step, triggerResize()
  $: copy, triggerResize()
  
  // TODO: refactor. this is wonky.
  // Trigger window resize event, which triggers JointJS shape updates
  function triggerResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize-with-ease'));
    }, 0);
  }
    
</script>

{#if visible}
  <div 
    id={'box-'+id}
    class="box"
    transition:fade
    >
    <!-- 
    style="
    --position_top:   {position.top};
    --position_left:  {position.left};
    --position_bottom:{position.bottom};
    --position_right: {position.right};
    --size_width:     {size.width};
    --size_height:    {size.height};
    --size_min_width: {size.min_width};
    --size_min_height:{size.min_height};
    --size_max_width: {size.max_width};
    --size_max_height:{size.max_height};
    ">
    -->
    <!-- css_custom_property : { svelte.component.prop || default } -->
    <!-- --size_max_width: {size.max_width || '25%'}; -->

    {#if headline}
      <h1>{headline}</h1>
    {/if}
    {#if copy}
      {#if step <= 0 }
        <p class="copy step-1" in:fade|local>{@html copy[step]}</p>
      {:else if step > 0}
        <p class="copy step-2" in:fade|local>{@html copy[step]}</p>
      {/if}
    {/if}
  </div>
{/if}

<style>
  div {
    /*position: absolute; /* prevent boxes from pushing each other down during in/out-transition */

    /* 
      prevent boxes from pushing each other down during in/out-transition
      without using position:absolute. 
      requires display:grid on parent container.
    */
    grid-row: 1;
    grid-column: 1;

    padding: 0.8em;

    /*
    top:    var(--position_top);
    left:   var(--position_left);
    bottom: var(--position_bottom);
    right:  var(--position_right);
    */
    /*
    width:      var(--size_width);
    height:     var(--size_height);
    min-width:  var(--size_min_width);
    min-height: var(--size_min_height);
    max-width:  var(--size_max_width);
    max-height: var(--size_max_height);
    */
  }

  .copy {
    margin-top: 0.2rem;
  }

  .copy.step-1 {
    color: var(--color-blue-light);
  }

  .copy.step-2 {
    color: var(--color-blue-dark);
  }
</style>
